import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import type { AxiosError } from 'axios';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import {
  type ConnectorApiError,
  updateConnectorsStatusApi,
  type UpdateConnectorsStatusRequest,
} from '@/entities/connector';

export const useUpdateConnectorsStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: UpdateConnectorsStatusRequest) => updateConnectorsStatusApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: connectorKeys.all });

      message.success(NOTIFICATION_MESSAGES.CONNECTOR_STATUS_UPDATE_ALL_SUCCESS_DESC);
    },
    onError: (error: AxiosError<ConnectorApiError>) => {
      const errorMessage = error.response?.data?.message ?? NOTIFICATION_MESSAGES.CONNECTOR_STATUS_UPDATE_ERROR_DESC;
      message.error(errorMessage);
    },
  });
};
